import i18n from '@/plugins/i18n'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { BuilderModule } from './types'

const builder: BuilderModule = {
  state: {
    app: null,
    appSelectedType: 'NONE',
    appType: 'TYPE_BLOGER',
    profile: {
      color: '#779DE9',
    },
    channels: [],
    phone: '',
    appCurrency: 'RUB',
    secretKey: {
      id: 0,
      value: ''
    },
    promotionalPage: null
  },
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default builder
